package com.dotdrives.model

/**
 * `reminders.description` is member-readable and is copied verbatim into the
 * `reminder.created` event payload, so an automation template must never interpolate a value
 * read from a `has_perm_strict`-gated table (`donations`, `pledges`, `drive_financials`) --
 * docs/schema.md. Matches any `{token}` whose name contains "amount" or "total", which covers
 * every real money column across those tables (`amount`, `fee_amount`, `proposed_amount`,
 * `pledged_amount`, `received_amount`, ...) as well as the two literal tokens
 * (`{amount}`, `{total}`) the schema names explicitly -- not just an exact match on those two.
 *
 * The single definition here is shared by the controller-level draft gate
 * (`AutomationRulesController.setDraftDescriptionTemplate`) and the client write-boundary
 * backstop ([requireNoMoneyToken], used by `AutomationRuleClient.create`) -- one regex, not
 * copies drifting apart across files.
 */
private val MONEY_TOKEN_REGEX = Regex("\\{[^{}]*(amount|total)[^{}]*\\}", RegexOption.IGNORE_CASE)

fun containsMoneyToken(text: String): Boolean = MONEY_TOKEN_REGEX.containsMatchIn(text)

/** The last line of defense at the write boundary: throws if [text] carries a money token,
 * independent of whether any earlier UI-level gate was somehow bypassed. */
fun requireNoMoneyToken(text: String) {
    require(!containsMoneyToken(text)) { "Automation templates may not interpolate a money value" }
}
